var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-nav-item-dropdown',{attrs:{"right":_vm.right}},[_vm._t("button-content",null,{"slot":"button-content"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }